import React from 'react';
import {
    Avatar, Button, ButtonGroup, Cell, Chip,
    Div, FormItem, Headline, IconButton, NativeSelect,
    PanelHeader, SplitCol, SplitLayout, Textarea, Title
} from '@vkontakte/vkui';
import {AdaptivityContext, formatQnt, getGUID, setQuizStep} from "../assets/constants";
import Fancybox from "../assets/fancybox";
import moment from "moment";
import * as constants from "../assets/constants";
import {
    Icon16Clear, Icon20ListPlusOutline,
    Icon24Story,
    Icon28PicturePlusOutline
} from "@vkontakte/icons";
import KBInput from "../assets/KBInput";
import Autocomplete from "../assets/autocomplete";

class DefectiveAct extends React.Component {


    state = {
        items_monitoring: {},
        series: [],
        loading: true,
        current_komment: '',
        current_qnt: '',
        current_komment_error: '',
        current_doc: '',
        current_doc_error: '',
        current_qnt_error: ''
    }

    constructor(props) {
        super(props);
        this.GUID = getGUID()
    }

    setKomment = (e) => {

        this.setState({current_komment: e.target.value})
    }
    addSeria = () => {
        const old = this.state.series

        old.push({code: '', qnt: ''})
        this.setState({series: old})
        this.getTotal(old)
    }
    getTotal = (olds) => {
        const total_ = olds.reduce((total, item) => total + item.qnt * 1, 0)
        this.setQnt(total_)
    }
    setSeriesQnt = (value, index) => {
        const olds = this.state.series

        const old = olds[index]
        old.qnt = value
        olds[index] = old
        this.setState({series: olds})

        this.getTotal(olds)
    }
    setSeriesCode = (value, index) => {

        console.log(value)

        const olds = this.state.series

        const old = olds[index]
        old.code = value
        olds[index] = old
        this.setState({series: olds})

        this.getTotal(olds)
    }

    removeSeria = (index) => {
        const olds = this.state.series

        olds.splice(index, 1)
        this.setState({series: olds})

        this.getTotal(olds)
    }
    setQnt = (value) => {

        this.setState({current_qnt: value})
    }
    loadImages = () => {
        const data = localStorage.getItem(constants.photo_defective_act_key)
        if (data && data !== "undefined") {
            const allItems = JSON.parse(data)
            const items = allItems[this.props.product.GUID] ?? {}
            this.setState({items_monitoring: items})
            console.log(items)
        }
    }

    saveImages = (newItems = null) => {
        const data = localStorage.getItem(constants.photo_defective_act_key)
        let allItems = {}
        if (data && data !== "undefined") {
            allItems = JSON.parse(data)
        }
        this.setState({items_monitoring: newItems ?? {}})
        allItems[this.props.product.GUID] = newItems ?? this.state.items_monitoring

        localStorage.setItem(constants.photo_defective_act_key, JSON.stringify(allItems))
    }

    componentWillMount() {

        console.log('willMount')
        if(this.props.father.lastState){
            this.setState(this.props.father.lastState)
            return
        }
        const dataDef = localStorage.getItem(constants.data_defective_act_key)

        if (dataDef) {
            const data = JSON.parse(dataDef)


            if (data && data[this.props.product.GUID]) {
                const {qnt, comment, doc, series} = data[this.props.product.GUID]
                this.setState({current_qnt: qnt, current_komment: comment, current_doc: doc, series})
            }
        }
    }

    componentDidMount() {
        this.loadImages()
        window.addEventListener("message", this.receiveMessage, false)

    }

    componentWillUnmount = () => {
        this.saveImages(this.state.items_monitoring ? this.state.items_monitoring : {})
        window.removeEventListener("message", this.receiveMessage)

    }
    clearPhoto = (num = 0) => {
        let items = this.state.items_monitoring ? this.state.items_monitoring : {}

        if (items[num] != undefined) {
            delete items[num]
        }
        this.saveImages(items)
    }

    getPhoto = (num = 0) => {

        const {current_qnt, current_komment, current_doc, series} = this.state
        this.props.father.lastState = {current_qnt, current_komment, current_doc, series}
        if (this.props.father) {
            this.props.father.setState({
                activePanelIncoming: 'incoming_photo_panel',
                IncomingImageEventName: "setDefectiveImage",
                lastIncomingPanel: this.props.father.state.activePanelIncoming,
                numIncomingImage: num,
            })
        }
    }

    receiveMessage = (event) => {

        if (event.data.type != undefined && event.data.type == 'reloadIncomingImages') {
            this.loadImages()
        }
        if (event.data == 'incomingGoGetBack') {
            setQuizStep(3, 'Incoming')
        }

    }

    render() {
        const images_url = this.props.base_url.replace("frontend/", '');
        const monitoring_photo = this.state.items_monitoring[0] ? this.state.items_monitoring[0] : {
            hasImage: false
        }
        const monitoring_photo2 = this.state.items_monitoring[1] ? this.state.items_monitoring[1] : {
            hasImage: false
        }
        const cnt = Object.keys(this.state.items_monitoring).length
        const product_series = []

        if (this.props.product.product_series) {
            this.props.product.product_series.map(el => {
                    if (!el.code) return
                    product_series.push({
                        label: el.code,
                        id: el.external_id
                    })
                }
            )
        }
        return (
            <SplitLayout>
                <SplitCol>
                    <PanelHeader fixed={true}>
                        <Div>
                            Приемка. Акт брака
                        </Div>
                    </PanelHeader>
                    <SplitLayout>
                        <SplitCol>
                            <Fancybox key={'IncomingDefectiveProductFancyBox'}>

                                <Div className="incoming-products-row" key={"incomingDefectiveProductRow1"}>
                                    <a data-fancybox={'gallery' + this.props.product.GUID}
                                       href={images_url + this.props.product.img.replace('https:/l', 'https://l').replace('https:/lab', 'https://lab').replace(images_url, '')}>
                                        {<Avatar mode="image" style={{borderRadius: '5%'}}
                                                 size={AdaptivityContext.isMobile ? 40 : 140}
                                                 src={images_url + 'image/200/200/' + this.props.product.img.replace('https:/l', 'https://l').replace('https:/lab', 'https://lab').replace(images_url, '')}
                                        />}
                                    </a>
                                    <div className="incoming-products-row_name">{this.props.product.name}</div>
                                    <div
                                        className="incoming-products-row_qnt-need">{formatQnt(this.props.product.quantity * 1, true)}
                                        <span
                                            className="incoming-products-row_qnt-need_unit">{this.props.product.unit.title}</span>
                                    </div>

                                    <div className="incoming-products-row_qnt">
                                        <KBInput readonly={this.state.series.length > 0 ||  product_series.length > 0 }
                                                 readonlyError={() => product_series.length > 0 && window.postMessage({
                                                     timeout: 4000,
                                                     type: 'error',
                                                     text: 'У товара есть серии, необходимо заполнить количество через список серий!'
                                                 })}
                                                 value={this.state.current_qnt}
                                                 onChange={this.setQnt}/>
                                    </div>
                                </Div>
                                {this.state.current_qnt_error &&
                                    <Div>
                                        <Headline style={{color: 'red'}}>{this.state.current_qnt_error}</Headline>
                                    </Div>}
                            </Fancybox>
                        </SplitCol>
                    </SplitLayout>
                    { product_series.length > 0 && <SplitLayout>
                        <SplitCol>
                            <Div>
                                <Title style={{display: 'flex', justifyContent: 'space-between'}}>
                                    Серии <Button mode="secondary"
                                                  onClick={() => this.addSeria()}
                                                  style={{width: "100px"}}><Icon20ListPlusOutline
                                    height={20}/></Button>
                                </Title>
                            </Div>
                            <div className='incoming-products-wrapper'>
                                {this.state.series ? this.state.series.map((series_item, index) => (
                                    <div style={{borderBottom: '#dadada 1px solid'}}
                                         className="incoming-products-row series">
                                        <div style={{width: '70%'}}>
                                            <FormItem bottom={series_item.code_error}
                                                      status={series_item.code_error ? 'error' : ''}>
                                                <Autocomplete value={series_item.code} items={product_series}
                                                              onChange={label => this.setSeriesCode(label, index)}/>
                                            </FormItem>
                                        </div>
                                        <div style={{width: '20%'}}>
                                            <FormItem>
                                                <KBInput value={series_item.qnt}
                                                         onChange={(value) => this.setSeriesQnt(value, index)}/>
                                            </FormItem>

                                        </div>
                                        <div>
                                            <Div>
                                                <IconButton mode="primary" mode="secondary"
                                                            onClick={() => this.removeSeria(index)}>
                                                    <Icon16Clear/>
                                                </IconButton>
                                            </Div>

                                        </div>
                                    </div>)) : ''}
                            </div>
                        </SplitCol>
                    </SplitLayout>}
                    <SplitLayout>
                        <SplitCol>
                            <Div>
                                <Title>
                                    Сделайте фото товара
                                </Title>
                            </Div>
                            <Cell before="Общий план" multiline={true}
                                  after={<Fancybox key={'Defective0MonitoringFancyBox'}>
                                      <div className="sale-doc-form_monitoring-avatar">
                                          {monitoring_photo.hasImage ?

                                              [<a data-fancybox={'galleryIncomingDefective0'}
                                                  href={images_url + monitoring_photo.mainImage.replace(images_url, '')}>
                                                  {<Avatar mode="image" style={{borderRadius: '5%'}}
                                                           size={AdaptivityContext.isMobile ? 100 : 260}
                                                           src={monitoring_photo.thumb}/>}
                                              </a>, <Cell before={<Chip
                                                  removable={false}>Дата</Chip>}>{moment(monitoring_photo.date).format('DD.MM.YYYY')}</Cell>]
                                              :
                                              <Avatar mode="image" style={{borderRadius: '5%'}}
                                                      onClick={() => this.getPhoto()}
                                                      size={AdaptivityContext.isMobile ? 100 : 260}
                                                      src={images_url + constants.EMPTY_IMG}/>
                                          }
                                      </div>
                                  </Fancybox>}></Cell>
                            <Cell before="Крупный план" multiline={true}
                                  after={<Fancybox key={'Defective1MonitoringFancyBox'}>
                                      <div className="sale-doc-form_monitoring-avatar">
                                          {monitoring_photo2.hasImage ?

                                              [<a data-fancybox={'galleryIncomingDefective1'}
                                                  href={images_url + monitoring_photo2.mainImage.replace(images_url, '')}>
                                                  {<Avatar mode="image" style={{borderRadius: '5%'}}
                                                           size={AdaptivityContext.isMobile ? 100 : 260}
                                                           src={monitoring_photo2.thumb}/>}
                                              </a>, <Cell before={<Chip
                                                  removable={false}>Дата</Chip>}>{moment(monitoring_photo2.date).format('DD.MM.YYYY')}</Cell>]
                                              :
                                              <Avatar mode="image" style={{borderRadius: '5%'}}
                                                      onClick={() => this.getPhoto(1)}
                                                      size={AdaptivityContext.isMobile ? 100 : 260}
                                                      src={images_url + constants.EMPTY_IMG}/>
                                          }
                                      </div>
                                  </Fancybox>}></Cell>

                            <FormItem top="Укажите документ"
                                      status={this.state.current_doc_error == '' ? '' : 'error'}
                                      bottom={this.state.current_doc_error}>
                                <NativeSelect style={{zIndex: 23}}
                                              value={this.state.current_doc ?? ''}
                                              onChange={(e) => this.setState({current_doc: e.target.value})}
                                >
                                    <option value="">Не указан</option>
                                    {Object.keys(this.props.current_docs).map((key, indexU) => {
                                        const itemU = this.props.current_docs[key]
                                        return <option value={itemU.external_id}>
                                            <span>{itemU.klient.title}</span> {itemU.nomerDoc} от {itemU.date}</option>
                                    })}
                                </NativeSelect>
                            </FormItem>
                            <hr/>
                            <FormItem top="Опишите причины"
                                      status={this.state.current_komment_error == '' ? '' : 'error'}
                                      bottom={this.state.current_komment_error}>
                                <Textarea placeholder="Комментарий"
                                          value={this.state.current_komment}
                                          onChange={this.setKomment}/>
                            </FormItem>
                            <hr/>
                            <Div>
                                <Title>Произвольные фото</Title>
                            </Div>
                            <Div className="incoming-photos-gallery">
                                <Fancybox key={'Defective2MonitoringFancyBox'}>
                                    {cnt > 1 ? <div className="main-catalog_product-wrapper_avatar"
                                                    style={{width: AdaptivityContext.isMobile ? '108px' : '268px'}}>
                                        <Button mode="secondary"
                                                onClick={() => this.getPhoto(cnt + 1)}
                                                style={{width: "100px"}}><Icon28PicturePlusOutline
                                            height={100}/></Button>
                                    </div> : ''}
                                    {Object.keys(this.state.items_monitoring).map((key, index) => {
                                        if (index < 2) return ''
                                        const item = this.state.items_monitoring[key]
                                        return (
                                            <div className="main-catalog_product-wrapper_avatar"
                                                 style={{width: AdaptivityContext.isMobile ? '108px' : '268px'}}>
                                                {item.hasImage ?

                                                    [<a data-fancybox={'galleryIncomingDefective' + index}
                                                        href={images_url + item.mainImage.replace('https:/l', 'https://l').replace(images_url, '')}>
                                                        {<Avatar mode="image" style={{borderRadius: '5%'}}
                                                                 size={AdaptivityContext.isMobile ? 100 : 260}
                                                                 src={item.thumb}/>}
                                                    </a>,
                                                        <ButtonGroup stretched>
                                                            <Button mode="outline" stretched size="s"
                                                                    onClick={() => {
                                                                        this.getPhoto(key)
                                                                    }}><Icon24Story/></Button>
                                                            <Button mode="outline" stretched size="s"
                                                                    onClick={() => {
                                                                        this.clearPhoto(key)
                                                                    }}><Icon16Clear/></Button>
                                                        </ButtonGroup>]
                                                    :
                                                    <Avatar mode="image" style={{borderRadius: '5%'}}
                                                            onClick={() => {
                                                                this.getPhoto(key)
                                                            }}
                                                            size={AdaptivityContext.isMobile ? 100 : 260}
                                                            src={images_url + constants.EMPTY_IMG}/>
                                                }
                                            </div>
                                        )

                                    })}
                                </Fancybox>
                            </Div>
                        </SplitCol>
                    </SplitLayout>
                    <SplitLayout>
                        <SplitCol>
                            <Div className="action-board">
                                <ButtonGroup mode="horizontal" stretched>
                                    <Button stretched size={AdaptivityContext.isMobile ? 'm' : 'l'}
                                            onClick={() => setQuizStep(3, 'Incoming')}>Отмена</Button>
                                    <Button stretched size={AdaptivityContext.isMobile ? 'm' : 'l'}
                                            onClick={() => this.saveDefectiveAct()}>Сохранить</Button>
                                </ButtonGroup>
                            </Div>
                        </SplitCol>
                    </SplitLayout>
                </SplitCol>
            </SplitLayout>)
    }

    saveDefectiveAct = () => {

        let errors = 0
        this.setState({current_komment_error: '', current_qnt_error: ''})
        if (!this.state.current_komment.trim()) {
            errors++
            this.setState({current_komment_error: 'Необходимо указать причины'})
        }

        if (!this.state.current_doc.trim()) {
            errors++
            this.setState({current_doc_error: 'Необходимо указать документ'})
        }

        if (1 * this.state.current_qnt == 0) {
            errors++
            this.setState({current_qnt_error: 'Необходимо указать количество брака'})
        }

        const olds = this.state.series
        olds.map((series_item, index) => {
            series_item.code_error = ''
            series_item.qnt_error = ''

            if (series_item.code.trim() == '') {
                errors++
                series_item.code_error = 'Необходимо указать номер бракованной серии!'
            }
            if (series_item.qnt * 1 == 0) {
                errors++
                series_item.code_error += '\r\n Необходимо указать количество бракованной серии'
            }
        })
        this.setState({series: olds})

        if (errors == 0) {
            window.postMessage({
                type: "saveDefectiveAct",
                qnt: this.state.current_qnt,
                comment: this.state.current_komment,
                doc: this.state.current_doc,
                series: olds
            })
        } else {
            window.postMessage({type: "error", text: "Нужно заполнить все поля корректно"})
        }
    }
}

export default DefectiveAct